import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import type { ContingencyProps } from './types.js';

/** `<Contingency>` component. */
export const Contingency = ({
  className,
  icon: Icon,
  message,
  ...props
}: ContingencyProps): ReactElement => (
  <div className={twMerge('flex flex-col items-center gap-16', className)} {...props}>
    <Icon className='fill-primary opacity-50' />
    <p className='text-center font-regular text-secondary'>{message}</p>
  </div>
);
